export default __webpack_public_path__ + "cff6a3028ecd837905b282e07c547709.svg";